export default __webpack_public_path__ + "static/media/demo1.1d5d10e1.png";